import { render } from "./App.vue?vue&type=template&id=2e367ae7&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2e367ae7&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/CDC/BaoCao/CDC_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__